module.exports = __webpack_public_path__ + "media/crash.9984670d.wav";